module.exports = __webpack_public_path__ + "static/media/Buildings Modern.95175baf.svg";